
export function validateEmail(email: string): boolean {
  return /^[\w-.+]+@([\w-]+\.)+[\w-]{2,}$/.test(email);
}
